import axios from "axios";

const reqData = {
  method: "GET",
  url: "",
  queryParams: {},
  formData: {},
  bodyParams: {},
  pathParams: [],
  data: {},
};

function makeHeaders() {
  const headers = {
    "Content-Type": "application/json",
  };
  return headers;
}

/*eslint-disable */
function makeHeaderWithToken(token) {
  const headers = {
    Authorization: `${"Bearer" + " "}${token}`,
    "Content-Type": "application/json",
  };
  return headers;
}

export async function defaultApi(url, method, details) {
  const token = localStorage.getItem("access_token");

  axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
  axios.defaults.xsrfCookieName = "csrftoken";
  axios.defaults.withCredentials = true;

  const URL = `${process.env.REACT_APP_API_URL}/api/`.toString();

  // Determine headers based on whether we're sending FormData
  let headers;
  if (details instanceof FormData) {
    // For FormData, only include Authorization header and let browser set Content-Type
    headers = token ? { Authorization: `${"Bearer" + " "}${token}` } : {};
  } else {
    // For JSON requests, include Content-Type header
    headers = token ? makeHeaderWithToken(token) : makeHeaders();
  }

  const api = axios.create({
    baseURL: URL,
    headers: headers,
  });

  let requestDetails = { ...reqData };
  requestDetails.url = url;
  requestDetails.method = method;
  requestDetails.data = details;
  return api(requestDetails).then(response => response);
}
